import { render, staticRenderFns } from "./SetPolicies.vue?vue&type=template&id=507df91d"
import script from "./SetPolicies.vue?vue&type=script&lang=js"
export * from "./SetPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports